import React from 'react';

const SarasImage = (props) => {
    const {
        src,
        link,
        alt = '',
        target = '_LargeImage',
        height,
        width,
        style,
        className,
        imgStyle,
        imgClassName,
        placeholder,
        onClick
    } = props;

    const [imageFailed, setImageFailed] = React.useState(false);
    const showImage = !!src && !imageFailed;

    const wrapperStyle = {
        height,
        width,
        ...style
    };

    const placeholderNode = placeholder || (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#eef3fb',
                border: '1px solid #d9e1f0',
                color: '#8a97aa',
                fontSize: '12px',
                boxSizing: 'border-box'
            }}
        >
            Image
        </div>
    );

    const imageNode = showImage ? (
        <img
            alt={alt}
            src={src}
            className={imgClassName}
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                display: 'block',
                ...imgStyle
            }}
            onError={() => setImageFailed(true)}
            onClick={onClick}
        />
    ) : (
        placeholderNode
    );

    if (link) {
        return (
            <a
                href={link}
                target={target}
                className={className}
                style={wrapperStyle}
                onClick={onClick}
            >
                {imageNode}
            </a>
        );
    }

    return (
        <div className={className} style={wrapperStyle} onClick={onClick}>
            {imageNode}
        </div>
    );
};

export default SarasImage;
